<app-header></app-header>

<!--<div class="container info-is-visible" [ngClass]="checkViewBanner() ? 'banner-is-visible' : ''">-->
<div class="container" [ngClass]="checkViewBanner() ? 'banner-is-visible' : ''">
  <app-promo-banner></app-promo-banner>
<!--  <div class="fixed-top-info">Adding new reports is currently unavailable while we make important improvements to the site. We are sorry for the inconvenience.</div>-->
  <router-outlet class="mt-3"></router-outlet>
</div>

<!--<div [ngClass]="(isAuthenticated() | async) && path !== '/user/register' ? '' : ''">-->
<!--  <div [ngClass]="(isAuthenticated() | async) && path !== '/user/register' ? '' : ''">-->
<!--    <div [ngClass]="(isAuthenticated() | async) && path !== '/user/register' ? '' : ''">-->
<!--    </div>-->
<!--  </div>-->
<!--</div>-->
